import { render, staticRenderFns } from "./ValidasiSKP.vue?vue&type=template&id=f52b8600&scoped=true&lang=html&"
import script from "./ValidasiSKP.vue?vue&type=script&lang=js&"
export * from "./ValidasiSKP.vue?vue&type=script&lang=js&"
import style0 from "./ValidasiSKP.vue?vue&type=style&index=0&id=f52b8600&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f52b8600",
  null
  
)

export default component.exports